

























import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import CardIcon from '@/components/Cards/CardIcon.vue'

@Component
class CardIconList extends Vue {
  @Prop() readonly data: ReadonlyArray<any> = []
  @Prop() readonly hasSubtitle: Boolean = false
  @Prop() readonly clipAngles: Boolean = false
  static options: any
}

export default defineComponent({
  name: 'CardIconList',
  components: { CardIcon },
  props: CardIconList.options.props,
})
